export default __webpack_public_path__ + "static/media/12.f13820a4.webp";